import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import cx from 'classnames';
import { Loader } from '@googlemaps/js-api-loader';
import { GoogleMap, Circle, Marker } from "@react-google-maps/api";
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import { googleMapAPI } from '../../config';
import { mapThemeStyle } from '../../helpers/mapThemeStyle';

import infoIcon from '/public/SiteIcons/information-button.svg';
import mapPinIcon from '/public/SiteIcons/map-pin-large.png';
import infoIconBlack from '/public/SiteIcons/information-button-black.svg';

import s from './PlaceMap.css';

const containerStyle = {
  width: '100%',
  height: '100%'
};
class PlaceMap extends Component {
  static propTypes = {
    lat: PropTypes.number,
    lng: PropTypes.number,
    isMapTouched: PropTypes.bool,
    onChange: PropTypes.any,
    change: PropTypes.any,
    mapSuccess: PropTypes.string,
    mapWarning: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      center: null,
      isMapTouched: false,
      markers: null,
      success: false,
      googleMapsApiLoaded: false,
      styles: [
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [{
            color: '#a4ddf5'
          }]
        }
      ]
    }
    this.handleMarkerDragEnd = this.handleMarkerDragEnd.bind(this);
  }

  async componentDidMount() {
    const { theme } = this.props;
    this.setState({ styles: mapThemeStyle(theme) });
    const loader = new Loader({
      apiKey: googleMapAPI,
      libraries: ['places'],
    });
    await loader.importLibrary("places");
    this.setState({ googleMapsApiLoaded: true });
  }

  componentDidUpdate(prevProps) {
    const { theme } = this.props;
    const { theme: prevTheme } = prevProps;
    if (theme !== prevTheme) {
      this.setState({
        styles: mapThemeStyle(theme)
      });
    }
  }

  UNSAFE_componentWillMount() {
    const { lat, lng, isMapTouched } = this.props;
    this.setState({
      center: {
        lat: Number(lat),
        lng: Number(lng),
      },
      isMapTouched: isMapTouched,
    });
  }

  geometryValue(value) {
    return value;
  }

  handleMarkerDragEnd(targetMarker) {
    const { change } = this.props;
    const { isMapTouched } = this.state;

    const center = {
      lat: targetMarker.latLng.lat(),
      lng: targetMarker.latLng.lng(),
      isMapTouched: true
    };
    this.setState({ center: center, isMapTouched: true });
    if (!isMapTouched) {
      this.setState({ success: true });
    }
    change("ListPlaceStep1", "lat", center.lat);
    change("ListPlaceStep1", "lng", center.lng);
    change("ListPlaceStep1", "isMapTouched", center.isMapTouched);
  }

  renderWarning(message) {
    const { isMapTouched, success } = this.state;
    if (!isMapTouched) {
      return (
        <div className={cx(s.alertContainer, s.alertDanger, 'alertDangerRtl')}>
          <img src={infoIcon} className={cx(s.dangerIcon, 'dangerIconRtl')} />
          <strong><span>{message}</span></strong>
        </div>
      );
    }
    if (isMapTouched && success) {
      return (
        <div className={cx(s.alertContainer, s.alertSuccess, 'alertDangerRtl')}>
          <img src={infoIconBlack} className={cx(s.dangerIcon, 'dangerIconRtl')} />
          <strong><span>{message}</span></strong>
        </div>
      );
    }

  }

  handleOnLoad = (map) => {
    const { center } = this.state;
    const markers = [{
      position: new google.maps.LatLng(center.lat, center.lng)
    }];
    const bounds = new google.maps.LatLngBounds();
    markers.forEach(({ position }) => bounds.extend(position));
    map.fitBounds(bounds);
  };

  render() {
    const { mapWarning, mapSuccess } = this.props;
    const { isMapTouched, center, styles, googleMapsApiLoaded } = this.state;
    let message = !isMapTouched ? mapWarning : mapSuccess;

    return (
      <div className={s.positionRelative}>
        <div className={s.positionAbsolute}>{this.renderWarning(message)}</div>
        <div style={{ height: 554 }} className={s.tabViewMap}>
          {googleMapsApiLoaded ?
            <GoogleMap
              mapContainerStyle={containerStyle}
              onLoad={this.handleOnLoad}
              defaultZoom={14}
              center={center}
              options={{
                backgroundColor: '',
                scrollwheel: false,
                maxZoom: 16,
                minZoom: 11,
                streetViewControl: false,
                zoomControlOptions: {
                  position: google.maps.ControlPosition.LEFT_TOP
                },
                mapTypeControl: false,
                styles: styles
              }}
            >
              <Circle
                center={center}
                radius={100}
                options={{
                  fillColor: '#00d1c1',
                  strokeColor: '#007A87',
                }}
              />
              <Marker
                position={new google.maps.LatLng(center.lat, center.lng)}
                draggable={true}
                onDragEnd={(event) => this.handleMarkerDragEnd(event)}
                icon={{
                  url: mapPinIcon,
                  scaledSize: new google.maps.Size(34, 55),
                }}
              />
            </GoogleMap> : <></>
          }
        </div>
      </div>
    );
  }
}

const mapState = (state) => ({
  theme: state.currency.theme
});

const mapDispatch = {
  change
};

export default withStyles(s)(connect(mapState, mapDispatch)(PlaceMap));